// 判断Android or IOS
function isMobileDevice() {
    let ua = navigator.userAgent;
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/);
    return isIphone || isAndroid;
}

// 判断用户移动设备
function is_mobile() {
    let reg = /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i;
    return reg.test(navigator.userAgent.toLowerCase());
}

// 判断是否是微信端
function isWeiXin() {
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
}

// uuid随机字符串加数字命名
function uuid() {
    let s = [];
    let hexDigits = "0123456789abcdef";
    for (let i = 0; i < 32; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = "-";
    let uuid = s.join("");
    return uuid;
}

// 过滤特殊符号及空格
function Trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "");
}

// 分割字符串
function SplitStr(str, mark) {
    let s = str,
        ss;
    // 在每个空格字符处进行分解。
    ss = s.split(mark);
    return ss;
}

// 取随机数
function RDF(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
}

/**
 *@private 适应PC
 *@el 当前内容主体
 */
function CanvasScaleToWindow(el) {
    let WH = window.innerHeight;
    if (is_mobile()) {
        // if (WH > 1480) {
        // 	el.style.cssText = `transform:scale(${WH/1480});transform-origin:center top;`
        // }else{
        // 	el.style.transform = `translateY(-${(1480-WH)/2}px)`
        // }
    } else {
        document.getElementById("app").style.height = "1480px";
        el.style.cssText = `transform:scale(${WH /
            1480});transform-origin:center top;display:block;margin:0 auto;height:1480px`;
    }
}

/**
 *  blob转file
 * @param {blob文件} theBlob
 * @param {文件名} fileName
 */
function blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
}

/**
 * @param {base64字符串} urlData
 * @returns 转换后的blob文件
 */
function Base64ToBlob(urlData) {
    let arr = urlData.split(",");
    let _arr = arr[1].substring(0, arr[1].length - 2);
    let mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(_arr),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
        type: mime
    });
}

/**
 * 防抖
 * @param delay 间隔时间
 */
function debounce(fn, delay = 100) {
    let timer = null;
    return function() {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(this, arguments);
            timer = null;
        }, delay);
    };
}

/**
 *  节流函数
 * @param fn 需要执行的函数
 * @param delay 间隔时间
 */
function throttle(fn, delay = 100) {
    // 首先设定一个变量，在没有执行我们的定时器时为null
    let timer = null;
    return function() {
        // 当我们发现这个定时器存在时，则表示定时器已经在运行中，需要中止执行
        if (timer) return;
        timer = setTimeout(() => {
            fn.apply(this, arguments);
            timer = null;
        }, delay);
    };
}

export {
    is_mobile,
    RDF,
    SplitStr,
    Trim,
    uuid,
    isWeiXin,
    isMobileDevice,
    CanvasScaleToWindow,
    blobToFile,
    Base64ToBlob,
    debounce,
    throttle
};



// WEBPACK FOOTER //
// ./src/Toolset.js